import _ from 'lodash'

/**
 * the type of value could be string, array or object
 * convert it to object-like: {} / []
 */
export const convertPropClass2ClassObjectLike = function (classValue) {
  if (_.isObject(classValue) && !_.isArray(classValue)) {
    return classValue
  }

  if (_.isString(classValue)) {
    classValue = _.trim(classValue).split(/\s+/)
  }

  return _.reduce(
    classValue,
    (o, className) => {
      o[className] = true
      return o
    },
    {},
  )
}

/**
 * get prop value in object by prop path
 */

export function getPropByPath(obj, path, strict) {
  let tempObj = obj
  path = path || ''
  path = path.replace(/\[(\w+)\]/g, '.$1')
  path = path.replace(/^\./, '')

  let keyArr = path.split('.')
  let i = 0
  for (let len = keyArr.length; i < len - 1; ++i) {
    if (!tempObj && !strict) break
    let key = keyArr[i]
    if (key in tempObj) {
      tempObj = tempObj[key]
    } else {
      if (strict) {
        throw new Error(`请提供正确的prop路径属性：${path}`)
      }
      break
    }
  }
  return {
    obj: tempObj,
    key: keyArr[i],
    value: tempObj ? tempObj[keyArr[i]] : null,
  }
}
